"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
var pagination_1 = require("@fuze/apis-core/dist/pagination");
var getDefaultHeaders_1 = __importDefault(require("@fuze/apis-core/dist/getDefaultHeaders"));
/**
 * Get a list of zero or more acceptances (all current and past)
 *   zero found == new customer
 *   one or more found == current customer
 *
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param pagination A PaginationRequest object used to filter the results
 */
function getAcceptances(baseUrl, wardenToken, pagination) {
    if (pagination === void 0) { pagination = {
        offset: 0,
        limit: 50
    }; }
    var serializedPagination = (0, pagination_1.serializePagination)(pagination);
    return (0, http_client_1.default)({
        method: "GET",
        url: baseUrl + "/v1/acceptances?" + serializedPagination,
        headers: (0, getDefaultHeaders_1.default)(wardenToken)
    }).then(function (response) { return response.data; });
}
exports.default = getAcceptances;
